<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-24 18:32:33
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-19 17:31:59
-->
<template>
	<div>
		<span v-if="column.key == 'recommend_type'">{{ cellValue ? cellValue : '暂无' }}</span>
		<span v-else class="text"></span>
			{{ prefixIcon }}{{ Array.isArray(cellValue) ? cellValue.toString() : cellValue
			}}{{ column.key == 'commission_rate' && cellValue != '-' ? '%' : '' }}
		</span>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';

export default {
	name: 'TextCell',
	mixins: [mixin],
};
</script>

<style scoped>
.text {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	color: #1d2129;
}
</style>
